(function () {
  'use strict';

  var DRAWER_IDS = ['appointment-drawer', 'price-request-drawer'];
  var STORAGE_KEY = 'seedLastSubmittedDrawer';
  var CLOSE_DELAY = 1900;
  var SUCCESS_PARAM = 'contact_posted';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function getDrawers() {
    return DRAWER_IDS.map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);
  }

  function openDrawer(drawer) {
    if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      drawer.setAttribute('open', '');
    }
  }

  function closeDrawer(drawer) {
    if (typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      drawer.removeAttribute('open');
    }
  }

  function showSuccess(drawer) {
    var form = drawer.querySelector('form.appointment-form') || drawer.querySelector('form');
    if (!form) return;

    var submitBtn = form.querySelector('[data-appointment-submit]');
    var statusEl = form.querySelector('[data-appointment-status]');

    form.classList.add('is-submitted');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-success');
    }
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.classList.remove('is-error');
      statusEl.classList.add('is-success');
    }

    openDrawer(drawer);
    window.setTimeout(function () {
      closeDrawer(drawer);
    }, CLOSE_DELAY);
  }

  function stripSuccessParam() {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.delete(SUCCESS_PARAM);
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  function bind() {
    var drawers = getDrawers();
    if (!drawers.length) return;

    drawers.forEach(function (drawer) {
      var form = drawer.querySelector('form.appointment-form') || drawer.querySelector('form');
      if (form && form.dataset.appointmentBound !== '1') {
        form.dataset.appointmentBound = '1';
        var submitBtn = form.querySelector('[data-appointment-submit]');

        form.addEventListener('submit', function () {
          form.classList.add('is-loading');
          try {
            window.sessionStorage.setItem(STORAGE_KEY, drawer.id);
          } catch (e) {
            // Storage unavailable (e.g. private mode) - success animation falls back to the first drawer
          }
          if (submitBtn) {
            window.setTimeout(function () { submitBtn.disabled = true; }, 0);
          }
        });
      }
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get(SUCCESS_PARAM) === 'true') {
      var lastId = null;
      try {
        lastId = window.sessionStorage.getItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }

      var target = drawers.filter(function (drawer) { return drawer.id === lastId; })[0] || drawers[0];
      showSuccess(target);

      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }

      stripSuccessParam();
    }
  }

  ready(bind);
  document.addEventListener('shopify:section:load', bind);
})();